import { useState, useEffect } from "react";




const years = Array.from({ length: 26 }, (_, i) => 2025 - i);
const categories = [
    "Original Research Article",
    "Review Article",
    "Case Study",
    "Short Communication",
    "Book Chapter",
];
const subjects = [
    "Pharmaceutical Science",
    "Medical Science",
    "Biological Science",
];

const SearchPage = () => {
    const [filters, setFilters] = useState({ years: [], categories: [], subjects: [] });
    const [query, setQuery] = useState("");
    const [showSidebar, setShowSidebar] = useState(window.innerWidth >= 768);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);  // Default to 5 items per page
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Track the state of showing more filters
    const [showMoreYears, setShowMoreYears] = useState(false);
    const [showMoreCategories, setShowMoreCategories] = useState(false);
    const [showMoreSubjects, setShowMoreSubjects] = useState(false);

    const toggleFilter = (type, value) => {
        setFilters((prev) => {
            const updated = prev[type].includes(value)
                ? prev[type].filter((v) => v !== value)
                : [...prev[type], value];
            return { ...prev, [type]: updated };
        });
        setCurrentPage(1);
    };

    const filteredArticles = articles.filter((article) => {
        const matchYear =
            !filters.years.length ||
            filters.years.includes(new Date(article.createdAt).getFullYear());

        const matchCategory =
            !filters.categories.length || filters.categories.includes(article.articleCategory);

        const matchSubject =
            !filters.subjects.length || filters.subjects.includes(article.subject);

        const matchQuery =
            (article.title?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (article.author?.toLowerCase() || "").includes(query.toLowerCase());


        return matchYear && matchCategory && matchSubject && matchQuery;
    });

    const totalPages = Math.ceil(filteredArticles.length / itemsPerPage);
    const paginatedArticles = filteredArticles.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth < 768;

            if (!isMobile) {
                setShowSidebar(true); // Always show sidebar on desktop
                document.body.style.overflow = "auto";
            } else if (!showSidebar) {
                document.body.style.overflow = "auto";
            } else {
                document.body.style.overflow = "hidden";
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Run once on load

        return () => window.removeEventListener("resize", handleResize);
    }, [showSidebar]);



    // Function to handle entries per page change
    const handleEntriesChange = (e) => {
        setCurrentPage(1); // Reset to first page when entries per page changes
        setItemsPerPage(Number(e.target.value)); // Update itemsPerPage
    };

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await fetch(`https://backend.impactjournal.co.in/manuscript/all`); // adjust to your route
                if (!response.ok) throw new Error("Failed to fetch articles");
                const data = await response.json();
                setArticles(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);


    return (
        <div className="search-page">
            {/* Search Input + Entries */}
            <div className="search-page-header-impact">
                <div className="search-page-input-impact">
                    <i className="fa fa-search search-page-icon-impact"></i>
                    <input
                        type="text"
                        name="search"
                        id="search-input"
                        placeholder="Search articles or authors..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                </div>
            </div>

            <div className="toggle-sidebar-btn-entries-impact">
                {window.innerWidth < 768 && (
                    <button
                        className="toggle-sidebar-btn"
                        onClick={() => setShowSidebar((prev) => !prev)}
                    >
                        {showSidebar ? "Hide Filters" : "Show Filters"}
                    </button>
                )}

                <div className="entries-selector">
                    <label htmlFor="entries-per-page">Entries per page:</label>
                    <select
                        id="entries-per-page"
                        value={itemsPerPage}
                        onChange={handleEntriesChange}
                    >
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={150}>150</option>
                        <option value={200}>200</option>
                    </select>
                </div>
            </div>

            {/* Overlay */}
            {showSidebar && window.innerWidth < 768 && (
                <div className="filter-overlay" onClick={() => setShowSidebar(false)} />
            )}

            <div className="search-page-main-impact search-page-main-impact-1" >
                {/* Sidebar */}
                <div
                    className={`search-page-main-left ${window.innerWidth < 768 ? (showSidebar ? "show" : "") : ""
                        }`}
                >
                    {/* Year Filters */}
                    <div className="filter-group">
                        <h4>Filter by Year</h4>
                        {years.slice(0, showMoreYears ? years.length : 5).map((year) => (
                            <label key={year}>
                                <input
                                    type="checkbox"
                                    checked={filters.years.includes(year)}
                                    onChange={() => toggleFilter("years", year)}
                                />
                                {year}
                            </label>
                        ))}
                        {years.length > 5 && (
                            <button
                                className="show-more-btn"
                                onClick={() => setShowMoreYears((prev) => !prev)}
                            >
                                {showMoreYears ? "Show Less" : "Show More"}
                            </button>
                        )}
                    </div>

                    {/* Category Filters */}
                    <div className="filter-group">
                        <h4>Filter by Category</h4>
                        {categories.slice(0, showMoreCategories ? categories.length : 5).map((cat) => (
                            <label key={cat}>
                                <input
                                    type="checkbox"
                                    checked={filters.categories.includes(cat)}
                                    onChange={() => toggleFilter("categories", cat)}
                                />
                                {cat}
                            </label>
                        ))}
                        {categories.length > 5 && (
                            <button
                                className="show-more-btn"
                                onClick={() => setShowMoreCategories((prev) => !prev)}
                            >
                                {showMoreCategories ? "Show Less" : "Show More"}
                            </button>
                        )}
                    </div>

                    {/* Subject Filters */}
                    <div className="filter-group">
                        <h4>Filter by Subject</h4>
                        {subjects.slice(0, showMoreSubjects ? subjects.length : 5).map((subj) => (
                            <label key={subj}>
                                <input
                                    type="checkbox"
                                    checked={filters.subjects.includes(subj)}
                                    onChange={() => toggleFilter("subjects", subj)}
                                />
                                {subj}
                            </label>
                        ))}
                        {subjects.length > 5 && (
                            <button
                                className="show-more-btn"
                                onClick={() => setShowMoreSubjects((prev) => !prev)}
                            >
                                {showMoreSubjects ? "Show Less" : "Show More"}
                            </button>
                        )}
                    </div>
                </div>
                {/* Main Results */}
                <div className="search-page-main-right">
                    {paginatedArticles.length > 0 ? (
                        paginatedArticles.map((article, index) => (
                            <div key={index} className="search-page-article-item">
                                <div className="search-page-main-category-name">
                                    <p>{article.articleCategory}</p>
                                </div>
                                <div className="search-page-main-article-name">
                                    <h2><a style={{ color: "black" }}
                                        href={`https://backend.impactjournal.co.in/uploads/manuscripts/${article.file}`}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="download-article-title-link"
                                    >{article.articleTitle}</a></h2>
                                </div>
                                <div className="search-page-main-time-impact">
                                    <p>Published On - {new Date(article.createdAt).toLocaleDateString()}</p>
                                </div>
                                <div className="search-page-main-author-name">
                                    <p>{article.name}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No results found.</p>
                    )}

                    {/* Pagination */}
                    <div className="pagination-controls">
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                            <button
                                key={num}
                                className={`pagination-btn ${num === currentPage ? "active" : ""}`}
                                onClick={() => setCurrentPage(num)}
                            >
                                {num}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchPage;
